
import { defineComponent } from 'vue';
import {mapActions, mapGetters} from 'vuex'
import MobileAsideComponent from './MobileAsideComp.vue'

interface State {
	showMobAside: boolean
  value: string
}

export default defineComponent({
	name: 'HeaderComponent',
	data: (): State =>  ({
		showMobAside: false,
    value: '',
	}),
	components: {
		MobileAsideComponent
	},
	methods: {
    ...mapActions(["checkUnreadNotifications"]),
		toggleMobileNav() {
			this.showMobAside = !this.showMobAside
		},
    redirectToSearch() {
      this.$router.push({
        name: 'search',
        query: {
          query: this.value,
          page: 1
        }
      })

      this.value = ''
    }
	},
  mounted() {
    this.checkUnreadNotifications()
  },
  computed: {
		...mapGetters(["getLoggedStatus", "getNotificationStatus"])
	},
})
